import { currencyFormat } from './currencyFormat';

/**
 * An amount as a display string with its currency sign, e.g. `$522.72`.
 *
 * `currencyFormat` returns the digits only (`522.72`), so every caller that
 * wants a money string was prefixing the `$` itself — which is how the same
 * one-liner ended up in several files.
 *
 * Prefer the `AmountRow` component wherever a label/value row is being built:
 * it owns the credit and total variants, the struck-through state and the empty
 * placeholder. Reach for this only when a plain string is what the consumer
 * takes — a design-system block prop, for instance.
 */
export const formatMoney = (amount?: number | null): string => `$${currencyFormat(amount ?? 0)}`;

/**
 * A credit as the receipts render it, e.g. `-$25.00`.
 *
 * Sign-normalised, because the backend is inconsistent about whether a discount
 * arrives already negated; without this a pre-negated amount renders as `--$25`.
 */
export const formatMoneyCredit = (amount?: number | null): string =>
  `-${formatMoney(Math.abs(amount ?? 0))}`;
